export const [
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_STORE,
  RESET_PASSWORD_REQUEST_IS_MADE,
] = [
  "RESET_PASSWORD_REQUEST",
  "RESET_PASSWORD_STORE",
  "RESET_PASSWORD_REQUEST_IS_MADE"
]
